//@ts-check
import React from 'react';
import { Grid } from '@material-ui/core';
import Form from '../../../../../../../form';
import ToggleIcon from '../../../components/ToggleIcon';
import FontFamilyPicker from './FontFamilyPicker';
import FontSizePicker from './FontSizePicker';
import { getRgbString } from '../../../../../../../form/input/ColorButton/Color/utils';

var ElementStylesGroup = function ElementStylesGroup(_ref) {
  var element = _ref.element,
      onPropertyChange = _ref.onPropertyChange;
  return React.createElement(Grid, {
    container: true,
    spacing: 1
  }, React.createElement(Grid, {
    item: true,
    container: true,
    spacing: 1
  }, React.createElement(Grid, {
    item: true,
    xs: 7
  }, React.createElement(FontFamilyPicker, {
    value: element.fontFamily,
    onChange: function onChange(e) {
      return onPropertyChange('fontFamily', e.target.value);
    }
  })), React.createElement(Grid, {
    item: true,
    xs: 5
  }, React.createElement(FontSizePicker, {
    onChange: function onChange(value) {
      return onPropertyChange('fontSize', value);
    },
    value: element.fontSize
  }))), React.createElement(Grid, {
    item: true,
    container: true,
    alignItems: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Form.Input.ColorButton, {
    type: "background",
    value: element.backgroundColor,
    onChange: function onChange(e) {
      return onPropertyChange('backgroundColor', getRgbString(e.rgb));
    }
  })), React.createElement(Grid, {
    item: true
  }, React.createElement(Form.Input.ColorButton, {
    value: element.color,
    onChange: function onChange(e) {
      return onPropertyChange('color', getRgbString(e.rgb));
    }
  })), React.createElement(Grid, {
    item: true
  }, React.createElement(ToggleIcon, {
    type: "bold",
    label: "bold",
    checked: element.fontWeight === 'bold',
    onClick: function onClick() {
      return onPropertyChange('fontWeight', element.fontWeight === 'bold' ? 'normal' : 'bold');
    }
  })), React.createElement(Grid, {
    item: true
  }, React.createElement(ToggleIcon, {
    type: "italic",
    label: "italic",
    checked: element.fontStyle === 'italic',
    onClick: function onClick() {
      return onPropertyChange('fontStyle', element.fontStyle === 'italic' ? 'normal' : 'italic');
    }
  }))));
};

export default ElementStylesGroup;